import {
  LogoHauteGaspesie,
  LogoMutuoHorizontal,
  LogoRefrain,
  LogoSerresTessierHorizontal,
} from 'app/design/branding/logo';
import { LogoOneLine } from 'app/design/icons/logo-one-line';
import { LogoOneLinePartake } from 'app/design/icons/logo-one-line-partake';
import { isWhiteLabel } from 'app/utils/helpers';
import { useUISize } from 'app/utils/web-helpers';
import { View } from 'react-native';
import { useTheme } from 'app/shopify';
import { WhiteLabel } from '../../../types/white-labels';
import { env } from '../../env';

export function LogoComponent({ width, height }: { width?: number | string; height?: number | string }) {
  const theme = useTheme();
  const { isSmallUI } = useUISize();

  if (isWhiteLabel(WhiteLabel.Refrain)) {
    return (
      <View style={isSmallUI ? { marginTop: -15 } : undefined}>
        <LogoRefrain height={height ?? 75} width={width ?? 187} />
      </View>
    );
  }

  if (isWhiteLabel(WhiteLabel.SerresTessier)) {
    return (
      <View style={{ marginTop: 5 }}>
        <LogoSerresTessierHorizontal height={22} width={180} />
      </View>
    );
  }

  if (isWhiteLabel(WhiteLabel.Mutuo)) {
    return (
      <View style={{ marginTop: -5 }}>
        <LogoMutuoHorizontal height={23} width={138} />
      </View>
    );
  }

  if (isWhiteLabel(WhiteLabel.HauteGaspesie)) {
    return (
      <View>
        <LogoHauteGaspesie height={46} width={120} />
      </View>
    );
  }

  // prettier-ignore
  return env.IS_PARTAKE ? <LogoOneLinePartake /> : <LogoOneLine color={theme.colors['white-label.header.on-header']} />;
}
